<template>
  <div>
    <Grid :cards="cards" />
  </div>
</template>

<script setup lang="ts">
import Grid from "@/components/ui/Grid.vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";

interface LegalCard {
  title: string;
  description: string;
  link: string;
}

const { t, tm } = useI18n();

const cards = computed<LegalCard[]>(() => {
  // Get the array length dynamically
  const cardsArray = tm("legalOverview.cards") as unknown[];

  return cardsArray.map((_, i) => ({
    title: t(`legalOverview.cards[${i}].title`),
    description: t(`legalOverview.cards[${i}].description`),
    link: t(`legalOverview.cards[${i}].link`),
  }));
});
</script>
